import { Injectable } from '@angular/core';
// declare let THREE: any;
import { CameraService } from './camera.service';
import { RendererService } from './renderer.service';
import { Subject } from 'rxjs/Subject';

declare const THREE: any;
declare const window: any;

@Injectable()
export class StageService {
  scene = null;
  camera = null;
  mesh = null;
  grid = null;
  light = null;

  objectRemoved = new Subject<any>();
  objectAdded = new Subject<any>();

  constructor(private cameraManager: CameraService, private renderer: RendererService) {
    this.scene = new THREE.Scene();

    this.camera = this.cameraManager.camera;

    const geometry = new THREE.BoxGeometry(600, 200, 400);
    const material = new THREE.MeshBasicMaterial({ color: 0x00a5ce, wireframe: false });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.y += 100;
    window.stg = this.scene;
    window['scene'] = this.scene;
  }

  getScene() {
    return this.scene;
  }

  add(obj, parent?) {
    if (parent) {
      parent.add(obj);
    } else {
      this.scene.add(obj);
      // console.log('add scene', obj)
    }
    this.objectAdded.next(obj);
    this.render();
  }

  getChildren(predicate?) {
    return this.scene.children;
  }

  getCanvas() {
    return this.renderer.getCanvas();
  }

  render() {
    this.renderer.render(this.scene);
  }

  addMany(objs) {
    this.scene.add.apply(this.scene, objs);
    // Уведомляем о добавлении каждого объекта
    objs.forEach(obj => {
      this.objectAdded.next(obj);
    });
    this.render();
  }

  removeMany(objs) {
    this.scene.remove.apply(this.scene, objs);
    // Уведомляем об удалении каждого объекта
    objs.forEach(obj => {
      this.objectRemoved.next(obj);
    });
  }

  remove(obj) {
    if (obj && obj.parent) {
      obj.parent.remove(obj);
      this.objectRemoved.next(obj);
      this.render();
    }
  }

  getChildrenByPredicate(predicate) {
    const result = [];

    this.scene.traverse(function(obj) {
      if (predicate(obj)) result.push(obj);
    });

    return result;
  }

  findObject(predicate: (obj) => boolean) {
    const result = [];
    this.scene.traverse(obj => {
      if (predicate(obj)) {
        result.push(obj);
      }
    });

    if (result.length > 1) {
      throw new Error('there are multiple objects obey the predicate');
    }

    return result[0];
  }

  // most likely not needed
  getFloor() {
    return this.scene.getObjectByName('floor');
  }

  getCompoundFloor() {
    return this.scene.getObjectByName('compoundFloor');
  }

  getFloorById(index) {
    return this.scene.getObjectByName('compoundFloor').getObjectById(index);
  }

  getStairs() {
    const children = this.scene.getObjectByName('compoundFloor').children;
    return children
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name === 'stairs');
  }

  getTierSteps() {
    const children = this.scene.getObjectByName('compoundFloor').children;
    return children
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name === 'tierSteps');
  }

  getWalls() {
    const children = this.scene.getObjectByName('compoundFloor').children;
    return children
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name === 'wall');
  }

  getAccessories() {
    const children = this.scene.getObjectByName('compoundFloor').children;
    return children
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name === 'Accessory');
  }

  getAwnings() {
    const walls = this.getWalls();
    return walls
      .map(c => c.children)
      .reduce((acc, val) => acc.concat(val), [])
      .filter(c => c && c.name === 'Awning');
  }

  getWindowsDoorsByFloorAndWallId(floor: any, wallId: number): any[] {
    let windowsDoors = [];
    const walls = floor.children.filter(element => element.name === 'wall');
    const wall = walls.find(element => element.userData.uuid === wallId);
    windowsDoors =
      wall && wall.children.filter(obj => obj.name === 'Window' || obj.name === 'Door');

    return windowsDoors;
  }

  getAwningsByFloorAndWallId(floor: any, wallId: number): any[] {
    let awnings = [];
    const walls = floor.children.filter(element => element.name === 'wall');
    const wall = walls.find(element => element.userData.uuid === wallId);
    awnings = wall && wall.children.filter(obj => obj.name === 'Awning');

    return awnings;
  }

  getConnectionPoints() {
    return this.scene.children.filter(function(item) {
      return item.userData.isConnectionPoint;
    });
  }

  getWallById(index) {
    return this.scene.getObjectByName('Wall ' + index);
  }

  getObjectById(id) {
    return this.scene.getObjectById(id);
  }

  getObjectsBesideTheWall(wall) {
    const sceneObjects = this.getChildren().filter(function(ob) {
      return (
        !this.objectCheckerSrvc.isWallOrFloor(ob) &&
        !this.objectCheckerSrvc.isGeneric(ob) &&
        this.objectCheckerSrvc.isObject(ob)
      );
    });
    const wallDir = wall.getWorldDirection(new THREE.Vector3());
    const objectsBesideTheWall = [];
    let j = 0;
    for (let i = 0; i < sceneObjects.length; i++) {
      const objDir = new THREE.Vector3(
        sceneObjects[i].position.x - wall.position.x,
        0,
        sceneObjects[i].position.z - wall.position.z
      );
      const distance = objDir.x * wallDir.x + objDir.z * wallDir.z;
      if (distance < 100 && distance > 0) {
        objectsBesideTheWall[j] = sceneObjects[i];
        j++;
      }
    }
    return objectsBesideTheWall;
  }

  setObjectsVisibilityByPredicate(predicate, isVisible) {
    this.scene.traverse(function(item) {
      if (predicate(item)) item.visible = isVisible;
    });
  }

  getObjectByName(name) {
    return this.scene.getObjectByName(name);
  }

  getWallObjects(wallName) {
    return this.getChildrenByPredicate(function(obj) {
      return !(obj instanceof THREE.Mesh) && obj.userData.wall === wallName;
    });
  }

  getAllPosts() {
    return this.getChildren().filter(c => c && c.name === 'PostContainer');
  }

  getConnectionPointByIndex(index) {
    return this.scene.getObjectByName('connectionPoint ' + index);
  }

  replace(oldObj, newObj) {
    this.scene.remove(oldObj);
    this.scene.add(newObj);
  }

  setSize(w, h) {
    this.cameraManager.resize(w, h);
    this.renderer.resize(w, h);
  }

  getSprites(): Array<any> {
    return this.scene.children.filter(obj => obj.type === 'Sprite');
  }

  getGround() {
    return this.scene.getObjectByName('ground');
  }

  getAllExceptTheObject(object: any): Array<any> {
    const objects = this.scene.children.filter(obj => obj.userData.entity && obj.visible);
    const tiers = this.getCompoundFloor().children.filter(obj => obj !== object);
    const accs = [];
    for (let i = 0; i < tiers.length; i++) {
      // let c = tiers[0].children
      // let a = c.filter(obj => obj !== object && obj.name === 'Accessory');
      accs.push(...tiers[0].children.filter(obj => obj !== object && obj.name === 'Accessory'));
    }
    // return [...objects, ...tiers, ...accs];
    return [...tiers, ...accs];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stage.service.ts